import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';

const styles = theme => ({
  noData: {
    marginTop: '150px',
    height: '150px'
  }
});

export default compose(
  withRouter,
  withFirestore,
  withProps(({ profile, auth }) => ({
    profile,
    auth
  })),
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/campaign/deals/ContentComplete.enhancer.js